import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../core/breadcrumbs";
import { Link } from "react-router-dom";
import { Filter } from "react-feather";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
//import Select from "react-select";
import { DatePicker, Table } from "antd";
const { RangePicker } = DatePicker;
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ExpenseModal from "../../core/modals/FinanceAccount/expenseModal";
import { Calendar } from "feather-icons-react/build/IconComponents";
import axios from "axios";

const ExpensesList = () => {
    // const route = all_routes;
    const [selectedDate, setSelectedDate] = useState(null);
    //const [selectedDateTwo, setSelectedDateTwo] = useState(null);
    const [selectedExpenseId, setSelectedExpenseId] = useState(null);

    const handleDateChange = (dates) => {
        setSelectedDate(dates);
        if (dates) {
            fetchExpense(1, dates);
        } else {
            fetchExpense(1);
        }
    };
    const storedUserData = localStorage.getItem("user");
    const userDataa = JSON.parse(storedUserData);
    const roleName = userDataa?.data.role.roleName;
  
    // const handlerefChange = (date) => {
    //     setSelectedDateTwo(date);
    // };
   
    // const optionsOne = [
    //     { value: "chooseName", label: "Choose Name" },
    //     { value: "macbookPro", label: "Macbook Pro" },
    //     { value: "orange", label: "Orange" },
    // ];

    // const optionsTwo = [
    //     { value: "chooseStatus", label: "Choose Status" },
    //     { value: "computers", label: "Computers" },
    //     { value: "fruits", label: "Fruits" },
    // ];


    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const toggleFilterVisibility = () => {
        setIsFilterVisible((prevVisibility) => !prevVisibility);
    };

  const [expenses, setExpenses] = useState([]);

  const [shouldReloadData, setShouldReloadData] = useState(false)

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });

  useEffect(() => {
    fetchExpense(1);
  }, [shouldReloadData]);

  const fetchExpense = async (page = 1, dateRange = null) => {
    try {
      let url = `/expenses?page=${page}&limit=${pagination.pageSize}`;
      
      if (dateRange && dateRange[0] && dateRange[1]) {
        url += `&startDate=${dateRange[0].format('YYYY-MM-DD')}&endDate=${dateRange[1].format('YYYY-MM-DD')}`;
      }
      
      if (searchQuery) {
        url += `&search=${searchQuery}`;
      }

      const response = await axios.get(url);
      
      console.log("Fetched data:", response.data);
      setExpenses(response.data.data.expense);
      setPagination({
        ...pagination,
        current: page,
        total: response.data.data.total
      });
    } catch (error) {
      console.error("Error fetching expense:", error);
    }
  };

  const handleReloadData = () => {
    setShouldReloadData(!shouldReloadData);
  };

  const handleTableChange = (pagination) => {
    fetchExpense(pagination.current);
  };

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSearch = () => {
    fetchExpense(1);
  };

  
  const handleLinkClick = async (expenseId) => {
    setSelectedExpenseId(expenseId);
  };

  const columns = [
    {
      title: "Category Name",
      dataIndex: "CategoryName",
      // sorter: (a, b) => a.categoryName.length - b.categoryName.length,
    },
    {
      title: "Expense For ",
      dataIndex: "expenseFor",
      
    },

    {
        title: "Reference",
        dataIndex: "Reference",
        // sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
    {
      title: "Date",
      dataIndex: "Date",

    },
    
    {
      title: "Status",
      dataIndex: "Status",

    },
    
    {
      title: "Amount",
      dataIndex: "Amount",

    },

    {
      title: "Description",
      dataIndex: "Description",
    },

    {
       title: "Action",
       dataIndex: "action",
       render: (_, record) => (
         <div className="edit-delete-action">
           <Link
             className="me-2 p-2"
             to="#"
              data-bs-toggle="modal"
              data-bs-target="#edit-units"
             onClick={() => handleLinkClick(record.key)}
           >
             <i data-feather="download" className="feather-edit"></i>
           </Link>
           {roleName ==='Admin'&&(
           <Link
             className="confirm-text p-2"
             to="#"
             onClick={() => showConfirmationAlert(record.key)}
           >
              <i data-feather="download" className="feather-trash"></i>
           </Link>
           )}
         </div>
       ),
    },
  ];

  const MySwal = withReactContent(Swal);

  
  const showConfirmationAlert = (expenseId) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteExpense(expenseId);
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  const deleteExpense = async (expenseId) => {
    try {
      await axios.delete(`/expenses/${expenseId}`)
      handleReloadData();
    } catch (error) {
      console.error("Error deleting expense:", error);
    }
  };
  
  

  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="page-wrapper">
      <div className="content">
      
          <Breadcrumbs
            maintitle="Expenses List "
            subtitle="Manage Your expenses"
            addButton="Add New Expenses"
          />
      

        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="search" 
                    className="form-control form-control-sm formsearch" 
                    placeholder="Search by category name"
                    value={searchQuery}
                    onChange={handleSearchInputChange}
                  />
                  <button className="btn btn-searchset" onClick={handleSearch}>
                    <i data-feather="search" className="feather-search" />
                  </button>
                </div>
              </div>
              <div className="search-path">
                <Link
                  className={`btn btn-filter ${
                    isFilterVisible ? "setclose" : ""
                  }`}
                  id="filter_search"
                >
                  <Filter
                    className="filter-icon"
                    onClick={toggleFilterVisibility}
                  />
                  <span onClick={toggleFilterVisibility}>
                    <ImageWithBasePath
                      src="assets/img/icons/closes.svg"
                      alt="img"
                    />
                  </span>
                </Link>
              </div>
              
            </div>
            {/* /Filter */}
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              style={{ display: isFilterVisible ? "block" : "none" }}
            >
              <div className="card-body pb-0">
                  <div className="row">
                    {/* <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <User className="info-img" />
                        <Select
                          className="select select-height"
                          options={optionsOne}
                          defaultValue={optionsOne[0]}
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <StopCircle className="info-img" />
                        <Select
                          className="select select-height"
                          options={optionsTwo}
                          defaultValue={optionsTwo[0]}
                        />
                      </div>
                    </div> */}
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Calendar className="info-img" />
                        <div className="input-groupicon">
                        <RangePicker onChange={handleDateChange} value={selectedDate} format="YYYY-MM-DD" />
                          
                        </div>
                      </div>
                    </div>
                    
                    <div className="col-lg-4 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Link className="btn btn-filters ms-auto">
                          {" "}
                          <i
                            data-feather="search"
                            className="feather-search"
                          />{" "}
                          Search{" "}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Filter */}
            <div className="table-responsive">
            <Table
                  className="table datanew"
                  columns={columns}
                  dataSource={expenses.map((expense) => ({
                    key: expense._id,
                    CategoryName: expense.expenseCategory.expenseCategoryName,
                    expenseFor : expense.expenseFor,
                    Reference: expense.expenseReference,
                    Date: expense.expenseDate,
                    Status: (
                        <span className={`badge ${expense.expenseState ? 'badge-linesuccess' : 'badge-linedanger'}`}>
                          {expense.expenseState ? 'Active' : 'Inactive'}
                        </span>
                      ),
                      Amount: `Lkr.${expense.expenseAmount.toFixed(2)}`,
                    Description: expense.expenseDescription,
                  }))}
                  pagination={pagination}
                  onChange={handleTableChange}
                />
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>

      <ExpenseModal onExpenseAdded={handleReloadData} expenseId={selectedExpenseId}/>
    </div>
  );
};

export default ExpensesList;
